module.exports = __webpack_public_path__ + "202408221624/img/haixiu.7647cd3d.png";